import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { defaultStakeholdersIdMapState } from './state';
import { UpdateStakeholderReferenceRequest } from '@types';

export const coreStakeholdersIdMapSlice = createUpdateSyncSlice({
	name: 'CoreStakeholdersIdMap',
	state: defaultStakeholdersIdMapState,
	transform: (action: Array<UpdateStakeholderReferenceRequest>, state = {}) => {
		if (!action.length) {
			return state;
		}

		const updatedState: typeof state = {
			...state
		};

		for (const entry of action) {
			const existingEntry = state[ entry.stakeholderId ] ?? {};

			const updatedEntry = {
				...existingEntry,
				...entry
			};

			updatedState[ entry.stakeholderId ] = updatedEntry;
		}

		return updatedState;
	}
});
